export const FUZZY_MATCH_REQUEST_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  MATCHING_COMPLETE: 'MATCHING COMPLETE',
  FINALIZING: 'FINALIZING',
  FINALIZED: 'FINALIZED',
  ERROR: 'ERROR',
};

export const FUZZY_MATCH_REQUEST_TYPE = {
  TAG_UPLOAD: 'TAG_UPLOAD',
  VOTER_UPLOAD: 'VOTER_UPLOAD',
  CONTACT_UPLOAD: 'CONTACT_UPLOAD',
  VOLUNTEER_UPLOAD: 'VOLUNTEER_UPLOAD',
};

export const FUZZY_MATCH_REQUEST_TYPE_LABEL = {
  [FUZZY_MATCH_REQUEST_TYPE.TAG_UPLOAD]: 'Tags',
  [FUZZY_MATCH_REQUEST_TYPE.VOTER_UPLOAD]: 'Voters',
  [FUZZY_MATCH_REQUEST_TYPE.CONTACT_UPLOAD]: 'Contacts',
  [FUZZY_MATCH_REQUEST_TYPE.VOLUNTEER_UPLOAD]: 'Volunteers',
};
